<template>
  <div id="cust_login">   
    <CustLoginComponent></CustLoginComponent>     
  </div>
</template>

<script>

  import CustLoginComponent from '@/components/cust_components/cust_login_component.vue';
  
  export default {
      name: 'login',
      data() {
          return {
          }
      },
      components: {     
        CustLoginComponent,
      }
  }
</script>